import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { adminApi, setAdminToken, getAdminCsrf } from "../apiAdmin";
import { AdminAuthContext } from "../context/AdminAuthContext";
import "./AdminLoginStyles.css";

export default function AdminLogin() {
  const { login } = useContext(AdminAuthContext);
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    try {
      await getAdminCsrf();
      const { data } = await adminApi.post("/login", form);
      setAdminToken(data.accessToken);
      login(data.user, data.accessToken);
      navigate("/admin/dashboard");
    } catch (err: any) {
      setError(err.response?.data?.msg || "Error");
    }
  };

  return (
    <div id="adm-login-root">
      <form id="adm-login-box" onSubmit={handleSubmit}>
        <h2 id="adm-login-title">Admin Login</h2>
        <input
          id="adm-login-email"
          type="email"
          name="email"
          placeholder="Email"
          value={form.email}
          onChange={handleChange}
          required
        />
        <input
          id="adm-login-password"
          type="password"
          name="password"
          placeholder="Password"
          value={form.password}
          onChange={handleChange}
          required
        />
        <button id="adm-login-btn" type="submit">Login</button>
        {error && <p id="adm-login-error">{error}</p>}
      </form>
    </div>
  );
}
